import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import TabFilter from '../../../../common/tab-filter';
import { SimpleTooltip } from '../../../../common/tooltip';
import { getDefaultIfEmpty } from '../../../../helpers/Common';
import { formatTextFloat } from '../../../../helpers/Text';
import {
  cancelfetchDataClosing,
  fetchDataClosing,
  subscribeRealtimeTickClosing,
  changeFilterLineOne,
  changeFilterLineTwo,
  REDUCER_NAME,
  loadMoreClosing,
} from '../reducer';
import Const from './Const';
import Table from './Table';

const defaultSortState = { totalMatchVolume: 'desc' };

class Closing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sortState: defaultSortState,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { filter, currentSearch, watchListId } = this.props;
    const isChangeSortState = sortState !== prevState.sortState;
    if (
      filter !== prevProps.filter ||
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId ||
      isChangeSortState
    ) {
      this.fetchData();
      if (this.tableRef.current) {
        this.tableRef.current.scrollToTop();
      }
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataClosing } = this.props;
    cancelfetchDataClosing();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { fetchDataClosing, filter } = this.props;
    fetchDataClosing(
      Const.filterAvgVolume[filter.filterLineOne],
      Const.filterExceedPercent[filter.filterLineTwo],
      sortState,
    );
  };

  onLoadMore = page => {
    const { sortState } = this.state;
    const { loadMoreClosing, filter } = this.props;
    this.setState({
      page,
    });
    loadMoreClosing({
      page,
      sortState,
      currentAvgVolume: Const.filterAvgVolume[filter.filterLineOne],
      exceedingPercentage: Const.filterExceedPercent[filter.filterLineTwo],
    });
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickClosing } = this.props;
    subscribeRealtimeTickClosing(data);
  };

  changeAvgVolume = currentAvgVolume => {
    const { changeFilterLineOne, filter } = this.props;
    if (filter.filterLineOne !== currentAvgVolume) {
      changeFilterLineOne(currentAvgVolume);
    }
  };

  changeExceedPercent = currentPercent => {
    const { changeFilterLineTwo, filter } = this.props;
    if (filter.filterLineTwo !== currentPercent) {
      changeFilterLineTwo(currentPercent);
    }
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    const { page } = this.state;
    const { filter } = this.props;
    return (
      <div className="d-flex flex-fill flex-column">
        <div>
          <div className="list-filter top-nav">
            <span className="left-label-3 left-label">
              {I18n.t('tasignals.closingContent.line_2')}
            </span>
            <TabFilter
              currentTab={filter.filterLineOne}
              listTab="tasignals.filterAvgVolume"
              changeTab={this.changeAvgVolume}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label-3 left-label">
              {I18n.t('tasignals.closingContent.line_3.part_1')}
              <br />
              <small>{I18n.t('tasignals.closingContent.line_3.part_2')}</small>
            </span>
            <TabFilter
              currentTab={filter.filterLineTwo}
              listTab="tasignals.filterExceedPercent"
              changeTab={this.changeExceedPercent}
            />
          </div>
          <div className="list-text-display">
            <span className="light-text">
              {I18n.t('tasignals.closingContent.line_4.part_1')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.closingContent.line_4.part_2')}
            </span>
            <span className="bold-text">
              {formatTextFloat(
                Number(Const.filterAvgVolume[filter.filterLineOne]),
                0,
              )}
              <span className="light-text">
                {I18n.t('tasignals.closingContent.line_4.part_3')}
              </span>
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.closingContent.line_4.part_4')}
              {Const.filterExceedPercent[filter.filterLineTwo] * 100}
              {I18n.t('tasignals.closingContent.line_4.part_5')}
            </span>
            <span className="light-text">
              {I18n.t('tasignals.closingContent.line_4.part_6')}
            </span>
          </div>
        </div>
        <div className="mt-10 d-flex flex-fill">
          <Table
            page={page}
            onLoadMore={this.onLoadMore}
            scrollRef={this.tableRef}
            onSort={this.onSort}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDataClosing: (currentAvgVolume, currentPercent, sortState) =>
      dispatch(fetchDataClosing(currentAvgVolume, currentPercent, sortState)),
    cancelfetchDataClosing: () => dispatch(cancelfetchDataClosing()),
    subscribeRealtimeTickClosing: data =>
      dispatch(subscribeRealtimeTickClosing(data)),
    changeFilterLineOne: value => dispatch(changeFilterLineOne(value)),
    changeFilterLineTwo: value => dispatch(changeFilterLineTwo(value)),
    loadMoreClosing: value => dispatch(loadMoreClosing(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Closing);
